// AGC: Exports build-time-aware wagmi config shared by the entire app
// AGC: CRITICAL - Use build-time constant to tree-shake desktop connectors from Farcaster

import { getAppContext } from '../utils/farcaster-detection'
import type { Config } from 'wagmi'

/**
 * AGC: Build-time config selection
 * AGC: Vite replaces import.meta.env.VITE_APP_CONTEXT with literal string at build time
 * AGC: This allows dead code elimination to remove unused imports
 */

// AGC: Import both configs but only use one based on build-time constant
import { getFarcasterConfig } from './wagmi-farcaster'
import { desktopConfig, rainbowKitTheme as desktopTheme } from './wagmi'

const APP_CONTEXT = import.meta.env.VITE_APP_CONTEXT
const IS_MINI_APP_BUILD = APP_CONTEXT === 'farcaster' || APP_CONTEXT === 'baseapp'

export const config: Config = IS_MINI_APP_BUILD ? getFarcasterConfig() : desktopConfig

export const rainbowKitTheme = IS_MINI_APP_BUILD
  ? ({
      accentColor: '#7b3ff2',
      accentColorForeground: 'white',
      borderRadius: 'medium',
      fontStack: 'system',
      overlayBlur: 'small',
    } as const)
  : desktopTheme

export type AppContext = ReturnType<typeof getAppContext>

// AGC: Ensure wagmi's module augmentation references the unified config
declare module 'wagmi' {
  interface Register {
    config: typeof config
  }
}
